<template>
	<v-container>
		<v-row justify="center">
			<v-col cols="12">
				<v-card>
					<v-card-text class="text-end black--text">
						<div>Browser CodeName: {{ navigator.appCodeName }}</div>
						<div>Browser Name: {{ navigator.appName }}</div>
						<div>Browser Version: {{ navigator.appVersion }}</div>
						<div>Browser Language: {{ navigator.language }}</div>
						<div>Platform: {{ navigator.platform }}</div>
						<div>User-agent: {{ navigator.userAgent }}</div>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col cols="12">
				<v-card class="text-center">
					<div v-for="i in 25" :key="i">...</div>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	mixins: [require("@/mixins/router-mixin").default],
	computed: {
		navigator() {
			return navigator;
		}
	}
};
</script>